import * as DirectionPrimitive from '@radix-ui/react-direction';
import type { ReactNode } from 'react';

export interface TovDirectionProviderProps {
  children: ReactNode;
  dir: 'ltr' | 'rtl';
}

export function TovDirectionProvider({
  children,
  dir,
}: TovDirectionProviderProps) {
  return (
    <DirectionPrimitive.Provider dir={dir}>
      {children}
    </DirectionPrimitive.Provider>
  );
}

export const DirectionProvider = TovDirectionProvider;
